'use strict';

angular.module('flowingly.runner.templates').component('runnerTemplatesAdminTabs', {
    templateUrl: 'Client/runner.templates/admin/runner.templates.admin.tabs.component.tmpl.html'
});
